import gsap from "gsap";
import SplitType from 'split-type'
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

if(jQuery(window).width() >= 768){



    function init() {
        jQuery(".content > *:not(.block-callout.with-image)").addClass("item-animate").attr("data-delay", "0.3");
        jQuery(".content > .wp-block-image.size-full").removeClass("item-animate");
        jQuery(".block-callout.with-image > *").addClass("item-animate").attr("data-delay", "0.3");

        jQuery('.animated-section').css('opacity', 1);
        // for safari to fix some lagg
        ScrollTrigger.normalizeScroll(true);

        let sections = gsap.utils.toArray('.animated-section');
        // window.addEventListener('resize', resize);

        sections.forEach((section, i) => {

            let animatedItems = gsap.utils.toArray(section.querySelectorAll(".item-animate"));
            animatedItems.forEach((item, i) => {

                gsap.from(item, {
                    opacity: 0,
                    y: 57,
                    duration: 0.6,
                    delay: item.getAttribute("data-delay"),
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: item,
                        scrub: false,
                        start: "top 90%",

                    }
                })
            })

        })

        let listAnimations = gsap.utils.toArray('.animate-list');
        listAnimations.forEach((listAnimation, i) => {
            gsap.from(listAnimation.querySelectorAll("li"), {
                opacity: 0,
                y: 60,
                duration: 0.6,
                ease: "power2.out",
                stagger: { amount: 0.25 },
                delay: listAnimation.getAttribute("data-delay"),
                scrollTrigger: {
                    trigger: listAnimation,
                    scrub: false,
                    start:  "top 90%",
                }
            })
        })

        let rotateItems = gsap.utils.toArray('.rotate-item');

        // console.log(rotateItems);

        rotateItems.forEach((rotateItem, i) => {

            // console.log(rotateItems);

            gsap.from(rotateItem, {

                rotation: -120,
                duration: 0.6,
                ease: 'none',

                scrollTrigger: {
                    trigger: rotateItem,
                    scrub: 0.01,
                    start: "top 90%",

                }
            })
        })

        initResizeable();

    }

    function initResizeable(){
        let sections = gsap.utils.toArray('.animated-section');

        sections.forEach((section, i) => {
            let linesAnimations = gsap.utils.toArray(section.querySelectorAll(".animate-lines"));

            linesAnimations.forEach((lineAnimation, j) => {
                const text = new SplitType(lineAnimation, { types: 'lines' })

                gsap.from(text.lines, {
                    opacity: 0,
                    y: 80,
                    duration: 0.6,
                    stagger: { amount: 0.27 },
                    delay: j * 0.2,
                    scrollTrigger: {
                        trigger: lineAnimation,
                        scrub: false,
                        start: "top 90%",
                    }
                })
            })

        })
    }

    function resize() {
        let sections = gsap.utils.toArray('.section');

        sections.forEach((section, i) => {
            let linesAnimations = gsap.utils.toArray(section.querySelectorAll(".animate-lines"))
            linesAnimations.forEach((lineAnimation, j) => {gsap.killTweensOf(lineAnimation)})
        })
        initResizeable()
    }

    window.addEventListener('resize', resize);

    document.addEventListener('DOMContentLoaded', init);
}
